import request from '@/utils/request'

export default {
  //设备资源管理页面，获取设备列表
  getDevice: function (data) {
    return request({
      url: '/source/getDevice',
      method: 'GET',
      params: data
    })
  },
  addDevice: function (data) {
    return request({
      url: '/source/addDevice',
      method: 'POST',
      data: data
    })
  },
  updateDevice: function (data) {
    return request({
      url: '/source/updateDevice',
      method: 'POST',
      data: data
    })
  },
  deleteDevice: function (data) {
    return request({
      url: '/source/deleteDevice',
      method: 'POST',
      params: data
    })
  },
  addEditRecord: function (data) {
    return request({
      url: '/source/addEditRecord',
      method: 'POST',
      params: data
    })
  },
  getDeviceRecord: function (data) {
    return request({
      url: '/source/getDeviceRecord',
      method: 'GET',
      params: data
    })
  },
  getSearchDevice: function (data) {
    return request({
      url: '/source/getSearchDevice',
      method: 'GET',
      params: data
    })
  },
  //环境整改情况页面
  getMessage: data => {
    return request({
      url: '/cyt/getMessage',
      method: 'GET',
      params: data
    })
  },
  updateMessage: data => {
    return request({
      url: '/cyt/updateMessage',
      method: 'POST',
      data: data
    })
  },
  addMessage: data => {
    return request({
      url: '/cyt/addMessage',
      method: 'POST',
      data: data
    })
  },
  deleteMessage: data => {
    return request({
      url: '/cyt/deleteMessage',
      method: 'POST',
      params: data
    })
  },
  //分页查询
  searchRectify: data => {
    return request({
      url: '/cyt/searchRectify',
      method: 'GET',
      params: data
    })
  },
  //环境监督页面
  getSupervise: data => {
    return request({
      url: '/cyt/getSupervise',
      method: 'GET',
      params: data
    })
  },
  updateSupervise: data => {
    return request({
      url: '/cyt/updateSupervise',
      method: 'POST',
      data: data
    })
  },
  addSupervise: data => {
    return request({
      url: '/cyt/addSupervise',
      method: 'POST',
      data: data
    })
  },
  deleteSupervise: data => {
    return request({
      url: '/cyt/deleteSupervise',
      method: 'POST',
      params: data
    })
  },
  //分页查询
  getSearchSupervise: data => {
    return request({
      url: '/cyt/getSearchSupervise',
      method: 'GET',
      params: data
    })
  },

  //文件上传
  uploadfile: data => {
    return request({
      url: '/cyt/excelUpload',
      method: 'POST',
      params: data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  //获取所有屏幕
  getAllScreen: data => {
    return request({
      url: '/cyt/getAllScreen',
      method: 'GET',
      params: data
    })
  },


  //获取最新一期松动圈数据
  getVoidNewData: data => {
    return request({
      url: '/cyt/getVoidNewData',
      method: 'GET',
      params: data
    })
  },

  //获取最新一期松动圈数据
  getVoidAllData: data => {
    return request({
      url: '/cyt/getVoidAllData',
      method: 'GET',
      params: data
    })
  },
  

  //获取最新一期微震监测项目
  getMicroseNewData:data =>{
    return request({
      url: '/cyt/getMicroseNewData',
      method: 'GET',
      params: data
    })
  },

  //获取最新一期三维激光扫描数据
  getLazerNewData:data =>{
    return request({
      url: '/cyt/getLazerNewData',
      method: 'GET',
      params: data
    })
  },
  //获取全部三维激光扫描数据
  getLazerAllData:data =>{
    return request({
      url: '/cyt/getLazerAllData',
      method: 'GET',
      params: data
    })
  },
  //设置库存阈值
  setSourceTypeThresh:data=>{
    return request({
      url: '/source/setSourceTypeThresh',
      method: 'POST',
      params: data
    })
  },
  //导出工程材料数据
  exportAllData:data=>{
    return request({
      url: '/source/exportData',
      method: 'GET',
      params: data
    })
  },
  //导出设备资源数据
  exportDeviceData:data=>{
    return request({
      url: '/source/exportDeviceData',
      method: 'GET',
      params: data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/cyt.js